export enum AppSubdomain {
    accounts = 'account-settings',
    analytics = 'analytics',
    contact = 'contact',
    devCenter = 'devcenter',
    earn = 'earn',
    gigs = 'gigs',
    profiles = 'profiles',
    tcAcademy = 'academy',
    onboarding = 'onboarding',
    work = 'work',
    wallet = 'wallet',
    walletAdmin = 'wallet-admin',
    copilots = 'copilots',
    campus = 'campus',
    admin = 'system-admin',
    review = 'review',
    calendar = 'calendar',
    engagements = 'engagements',
    customer = 'customer',
    reports = 'reports',
    sales = 'sales',
    procurement = 'procurement',
    status = 'status',
    support = 'support',
    opportunities = 'opportunities'
}

export enum ToolTitle {
    accounts = 'Account Settings',
    analytics = 'Analytics',
    contact = 'Contact',
    devCenter = 'Dev Center',
    earn = 'Opportunity Feed',
    gigs = 'Gigs',
    profiles = 'Profiles',
    tcAcademy = 'Topcoder Academy',
    selfService = 'Self Service Challenges',
    onboarding = ' ',
    work = 'Work',
    wallet = 'Wallet',
    walletAdmin = 'Wallet Admin',
    copilots = 'Copilots',
    campus = 'Campus',
    admin = 'Admin',
    review = 'Review',
    calendar = 'Calendar',
    engagements = 'Engagements',
    customer = 'Customer',
    reports = 'Reports',
    sales = 'Sales',
    procurement = 'Procurement',
    status = 'Status',
    support = 'Support',
    opportunities = 'Opportunities',
    thrive = 'Thrive'
}

export const PageSubheaderPortalId: string = 'page-subheader-portal-el'
